import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'alerta',
  templateUrl: './alerta.component.html',
  styleUrls: ['./alerta.component.scss']
})
export class AlertaComponent extends ModalDirective {

  @Input() titulo: string = "";
  @Input() mensagem: string = "";

  @Input() textoBotaoOk: string = "OK";

  @ViewChild('modalAlerta')
	modalAlerta: ModalDirective;

  onOk(event) {
    this.modalAlerta.hide();
  }

  show(mensagem?: string, titulo?: string) {
    this.mensagem = mensagem;
    this.titulo = titulo;
    this.modalAlerta.show();
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/alerta/alerta.component.ts